import "./Faqs.scss";

import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Menu from "../../components/Menu/Menu";
import { MenuProps } from "../../components/Menu/MenuTypes";
import { defaultMenuProps } from "../../constants/constants";
import { getApiFaqs, deleteApiFaq } from "../../services/apiFaq";
import { types } from "../../constants/constants";
import { TableProps } from "../../components/Table/TableTypes";
import Table from "../../components/Table/Table";
import Button from "../../components/Button/Button";
import dayjs from "dayjs";
import 'dayjs/locale/es';

const Faqs = (): React.ReactElement => {
  const navigate = useNavigate();
  const [menuProps] = useState<MenuProps>(defaultMenuProps);
  const [faqs, setFaqs] = useState<TableProps['items']>([]);
  const [limit] = useState<number>(types.PAGE_SIZE);
  const [offset, setOffset] = useState<number>(0);
  const [totalFaqs, setTotalFaqs] = useState<number>(0);
  const [actions, setActions] = useState<TableProps["actions"]>([]);
  const [sortDirection, setSortDirection] = useState<number>(1);
  const [sortBy, setSortBy] = useState<string>('created_at');

  useEffect(() => {
    setActions([
      { name: 'Editar', onClick: editAction, icon: 'pencil' },
      { name: 'Borrar', onClick: deleteAction, icon: 'deleteIcon' }
    ]);
  }, []);

  useEffect(() => {
    getFaqs();
  }, [sortBy, sortDirection]);

  const getFaqs = async (): Promise<void> => {
    getApiFaqs({ limit, offset, sortBy, sortDirection })
      .then(async (response: any) => {
        setTotalFaqs(response.total);
        const results: TableProps['items'] = response.faqs && response.faqs.map((faq: any, index: number) => [
          { name: '#', value: index + 1 },
          { name: 'Id', value: faq._id },
          { name: 'Pregunta', value: faq.question, sortable: true, index: 'question' },
          { name: 'Creado', value: dayjs(faq.created_at).format('DD/MM/YYYY'), sortable: true, index: 'created_at', className: 'text-center' }
        ]);
        setFaqs(results);
      })
      .catch((error: any) => {
        console.log(error.message);
        setFaqs([]);
      });
  };

  const loadMoreFaqs = async (): Promise<void> => {
    const offsetPage = offset + limit;
    getApiFaqs({ limit, offset: offsetPage, sortBy, sortDirection })
      .then(async (response: any) => {
        const results: TableProps['items'] = response.faqs && response.faqs.map((faq: any, index: number) => [
          { name: '#', value: index + offsetPage + 1 },
          { name: 'Id', value: faq._id },
          { name: 'Pregunta', value: faq.question, sortable: true, index: 'question' },
          { name: 'Creado', value: dayjs(faq.created_at).format('DD/MM/YYYY'), sortable: true, index: 'created_at', className: 'text-center' }
        ]);
        setOffset(offsetPage);
        setFaqs(faqs.concat(results));
      })
      .catch((error: any) => {
        console.log(error.message);
      });
  };

  const editAction = (id: string): void => navigate(`/faqs/${id}`);

  const deleteAction = async (id: string): Promise<void> => {
    if (!window.confirm('¿Estás seguro de que quieres eliminar esta FAQ?')) return;
    try {
      await deleteApiFaq(id);
      getFaqs();
    } catch (error: any) {
      alert('Error al eliminar la FAQ');
    }
  };

  const doSortBy = (field: string): void => {
    setOffset(0);
    setSortBy(field);
    setSortDirection(sortDirection === 1 ? -1 : 1);
  };

  return (
    <React.Fragment>
      <div id="menu">
        <Menu items={menuProps.items} />
      </div>
      <div id="app-content">
        <header className="table-header mb-4">
          <h1>FAQs contenido exclusivo</h1>
          <Button className={'btn-orangebg ms-auto me-3'} value={'Añadir FAQ'} onClick={() => navigate('/faqs/crear')} />
          <span>Total registros: {totalFaqs}</span>
        </header>
        {faqs && faqs.length
          ? <Table items={faqs} actions={actions} doSortBy={doSortBy} />
          : <p>No hay FAQs</p>
        }
        {totalFaqs > faqs.length &&
          <div className="row mt-4">
            <div className="col-12 col-md-4 offset-md-4">
              <Button className={'btn-white m-auto'} value={'Cargar más'} onClick={loadMoreFaqs} />
            </div>
          </div>
        }
      </div>
    </React.Fragment>
  );
};

export default Faqs;
